function generateUrlWithTagRemoved(tagToRemove) {
  const updatedParams = new URLSearchParams(window.location.search);
  const activeTags = updatedParams.getAll('filter.p.tag');
  const remainingTags = activeTags.filter(tag => tag !== tagToRemove);
  updatedParams.delete('filter.p.tag');
  remainingTags.forEach(tag => updatedParams.append('filter.p.tag', tag));
  return `${window.location.pathname}?${updatedParams.toString()}`;
}

function getActiveFacetsContainer() {
  return (
    document.querySelector('.facets-vertical-sort .active-facets') ||
    document.querySelector('#ProductGridContainer .active-facets')
  );
}

function syncTagFacetsFromUrl(searchParamsString) {
  const query =
    searchParamsString !== undefined && searchParamsString !== null
      ? searchParamsString
      : window.location.search.slice(1);
  const urlParams = new URLSearchParams(query);
  const activeTags = urlParams.getAll('filter.p.tag');

  document.querySelectorAll('input[name="filter.p.tag"]').forEach((input) => {
    input.checked = activeTags.includes(input.value);
  });
}

function renderActiveTagFacetsFromUrl() {
  const activeFacetsContainer = getActiveFacetsContainer();
  if (!activeFacetsContainer) return;

  const activeTags = new URLSearchParams(window.location.search).getAll('filter.p.tag');

  activeFacetsContainer.querySelectorAll('facet-remove[data-tag_facet="tag"]').forEach((element) => {
    element.remove();
  });

  activeTags.forEach(function (value) {
    const full_tag = value;
    const show_tag = value.split('_').pop();

    if (
      activeFacetsContainer.querySelector(`[data-facet='${show_tag}']`) ||
      activeFacetsContainer.querySelector(`[data-ftagvalue="${full_tag}"]`)
    ) {
      return;
    }

    const facetHTML = `
      <facet-remove data-facet="${show_tag}" data-tag_facet="tag">
        <a href="${generateUrlWithTagRemoved(full_tag)}"
           class="f_brand_${show_tag} button" data-ftagvalue="${full_tag}" role="button">
          <span>${show_tag}</span>
          <svg aria-hidden="true" focusable="false" role="presentation" width="12" height="13"
               class="icon icon-close-small" viewBox="0 0 12 13" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </a>
      </facet-remove>
    `;

    const clearAll = activeFacetsContainer.querySelector('facet-remove[data-facet="clear_all"]');
    if (clearAll) {
      clearAll.insertAdjacentHTML('beforebegin', facetHTML);
    } else {
      activeFacetsContainer.insertAdjacentHTML('beforeend', facetHTML);
    }
  });
}

function updateCounts() {
  $('details').each(function () {
      const $details = $(this);
      const checkedCount = $details.find('input[name="filter.p.tag"]:checked').length;
      const $selectedSpan = $details.find('.facets__selected');

      if (checkedCount > 0) {
          $selectedSpan.text(`(${checkedCount})`);
        $('.main-content-grid .active-facets-vertical-filter .facets__heading').removeClass('filter_reset_hide')
      } else {
          $selectedSpan.text('');
        $('.main-content-grid .active-facets-vertical-filter .facets__heading').addClass('filter_reset_hide')
      }
  });
}
function show_reset(){
  var reset_url = new URLSearchParams(window.location.search);
  const hasTagFilter = reset_url.has('filter.p.tag') && reset_url.get('filter.p.tag');
  const hasAvailabilityFilter = reset_url.has("filter.v.availability");
  const hasPriceFilter = reset_url.has("filter.v.price.gte") || reset_url.has("filter.v.price.lte");
  if (hasTagFilter || hasAvailabilityFilter || hasPriceFilter) {
    $('.main-content-grid .active-facets-vertical-filter .facets__heading').removeClass('filter_reset_hide');
  } else {
    $('.main-content-grid .active-facets-vertical-filter .facets__heading').addClass('filter_reset_hide');
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedFilterSubmit = debounce((input) => {
      FacetFiltersForm.submitFilterFromInput(input);
    }, 300);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 300);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('change', (event) => {
        const target = event.target;
        if (target.type === 'checkbox' || target.type === 'radio') {
          event.stopPropagation();
          if (FacetFiltersForm.isLoading) return;
          FacetFiltersForm.beginFacetInteraction(target);
          this.debouncedFilterSubmit(target);
          return;
        }
        this.onSubmitHandler(event);
      });

      facetForm.addEventListener('input', (event) => {
        if (event.target.type === 'checkbox' || event.target.type === 'radio') return;
        this.debouncedOnSubmit(event);
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static isLoading = false;
  static requestGeneration = 0;
  static activeFetchController = null;
  static pendingFacetContext = null;

  static FACET_FORM_IDS = new Set([
    'FacetFiltersForm',
    'FacetFiltersFormMobile',
    'FacetSortForm',
    'FacetSortDrawerForm',
  ]);

  static isHostVisible(host) {
    return Boolean(host && host.getClientRects().length > 0);
  }

  static setFacetControlsDisabled(disabled) {
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      form.classList.toggle('facets-is-loading', disabled);
    });
  }

  static beginFacetInteraction(input) {
    const label = input?.closest?.('.mobile-facets__label');
    const jsFilter = input?.closest?.('.js-filter');

    FacetFiltersForm.clearFacetCheckboxPending();
    if (label && !label.classList.contains('mobile-facets__label--disabled')) {
      label.classList.add('facets-checkbox--pending');
    }

    FacetFiltersForm.pendingFacetContext = {
      input,
      filterIndex: jsFilter?.dataset?.index,
      label,
    };

    FacetFiltersForm.isLoading = true;
    FacetFiltersForm.setCollectionProductLoading(true);
    FacetFiltersForm.setFacetControlsDisabled(true);

    document.getElementById('ProductCount')?.classList.add('loading');
    document.getElementById('ProductCountDesktop')?.classList.add('loading');
    document.querySelectorAll('.mobile-facets__count').forEach((el) => {
      el.classList.add('loading');
    });
  }

  static clearFacetCheckboxPending() {
    document.querySelectorAll('.facets-checkbox--pending').forEach((el) => {
      el.classList.remove('facets-checkbox--pending');
    });
    FacetFiltersForm.pendingFacetContext = null;
  }

  static submitFilterFromInput(input) {
    if (!input) return;
    const event = { target: input };
    FacetFiltersForm.renderPage(FacetFiltersForm.collectSearchParams(event), event);
  }

  static setCountLoading(loading) {
    document.getElementById('ProductCount')?.classList.toggle('loading', loading);
    document.getElementById('ProductCountDesktop')?.classList.toggle('loading', loading);
    document.querySelectorAll('.mobile-facets__count').forEach((el) => {
      el.classList.toggle('loading', loading);
    });
  }

  static appendFormParams(params, form) {
    if (!form || !FacetFiltersForm.FACET_FORM_IDS.has(form.id)) return;

    if (form.id === 'FacetFiltersForm') {
      document.querySelectorAll('.no-js-list').forEach((el) => el.remove());
    }

    const serialized = new URLSearchParams(new FormData(form)).toString();
    if (serialized) params.push(serialized);
  }

  static collectSearchParams(event) {
    const params = [];
    const triggerForm = event?.target?.closest?.('form');

    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      if (form.id !== 'FacetSortForm' && form.id !== 'FacetSortDrawerForm') return;
      const host = form.closest('facet-filters-form');
      if (!FacetFiltersForm.isHostVisible(host)) return;
      FacetFiltersForm.appendFormParams(params, form);
    });

    if (triggerForm?.id === 'FacetFiltersFormMobile') {
      FacetFiltersForm.appendFormParams(params, triggerForm);
      return params.join('&');
    }

    const desktopForm = document.getElementById('FacetFiltersForm');
    const desktopHost = desktopForm?.closest('facet-filters-form');
    if (desktopForm && FacetFiltersForm.isHostVisible(desktopHost)) {
      FacetFiltersForm.appendFormParams(params, desktopForm);
    } else if (triggerForm) {
      FacetFiltersForm.appendFormParams(params, triggerForm);
    } else {
      document.querySelectorAll('facet-filters-form form').forEach((form) => {
        if (form.id === 'FacetFiltersFormMobile') return;
        const host = form.closest('facet-filters-form');
        if (!FacetFiltersForm.isHostVisible(host)) return;
        FacetFiltersForm.appendFormParams(params, form);
      });
    }

    return params.join('&');
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const sections = FacetFiltersForm.getSections();
    if (!sections.length) {
      FacetFiltersForm.finalizeCollectionUpdate();
      return;
    }

    if (FacetFiltersForm.activeFetchController) {
      FacetFiltersForm.activeFetchController.abort();
    }
    FacetFiltersForm.activeFetchController = new AbortController();
    const generation = ++FacetFiltersForm.requestGeneration;

    FacetFiltersForm.isLoading = true;
    if (!FacetFiltersForm.pendingFacetContext) {
      if (event?.target?.type === 'checkbox' || event?.target?.type === 'radio') {
        FacetFiltersForm.beginFacetInteraction(event.target);
      } else {
        FacetFiltersForm.setCollectionProductLoading(true);
        FacetFiltersForm.setFacetControlsDisabled(true);
        FacetFiltersForm.setCountLoading(true);
      }
    }
    FacetFiltersForm.toggleActiveFacets(true);

    FacetFiltersForm.searchParamsPrev = searchParams;
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    try {
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, generation)
          : FacetFiltersForm.renderSectionFromFetch(url, event, generation);
      });
    } catch (error) {
      if (generation === FacetFiltersForm.requestGeneration) {
        FacetFiltersForm.finalizeCollectionUpdate();
      }
    }
  }

  static applySectionResponse(html, event, generation) {
    if (generation !== FacetFiltersForm.requestGeneration) return;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderActiveFacets(new DOMParser().parseFromString(html, 'text/html'));
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.finalizeCollectionUpdate();
  }

  static renderSectionFromFetch(url, event, generation) {
    const signal = FacetFiltersForm.activeFetchController?.signal;

    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: responseText, url }];
        FacetFiltersForm.applySectionResponse(responseText, event, generation);
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        if (generation !== FacetFiltersForm.requestGeneration) return;
        FacetFiltersForm.finalizeCollectionUpdate();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, generation) {
    const cached = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cached) {
      if (generation === FacetFiltersForm.requestGeneration) {
        FacetFiltersForm.finalizeCollectionUpdate();
      }
      return;
    }
    FacetFiltersForm.applySectionResponse(cached.html, event, generation);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.getElementById('ProductGridContainer');
    const target = document.getElementById('ProductGridContainer');
    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl =
      parsed.getElementById('ProductCount') || parsed.querySelector('#ProductCountDesktop');
    const mobileCountEl =
      parsed.getElementById('ProductCountMobile') || parsed.querySelector('.mobile-facets__count');

    if (!countEl && !mobileCountEl) return;

    const countMarkup = countEl ? countEl.innerHTML : mobileCountEl.innerHTML;
    const mobileMarkup = mobileCountEl ? mobileCountEl.innerHTML : countMarkup;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.getElementById('ProductCountMobile');

    if (container) {
      container.innerHTML = countMarkup;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = countMarkup;
      containerDesktop.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = mobileMarkup;
      containerMobile.classList.remove('loading');
    }

    document.querySelectorAll('.mobile-facets__count').forEach((el) => {
      el.innerHTML = mobileMarkup;
      el.classList.remove('loading');
    });
  }

  static getCollectionProductEl() {
    return (
      document.getElementById('collection-product') ||
      document.getElementById('ProductGridContainer')?.querySelector('#collection-product, .collection')
    );
  }

  static setCollectionProductLoading(loading) {
    const collectionProduct = FacetFiltersForm.getCollectionProductEl();
    if (collectionProduct) {
      collectionProduct.classList.toggle('loading', loading);
    }
    document.getElementById('product-grid')?.classList.toggle('loading', loading);
    document
      .querySelector('#ProductGridContainer .js_products_holder')
      ?.classList.toggle('loading', loading);
  }

  static finalizeCollectionUpdate() {
    FacetFiltersForm.activeFetchController = null;
    FacetFiltersForm.setCollectionProductLoading(false);
    FacetFiltersForm.setCountLoading(false);

    syncTagFacetsFromUrl(FacetFiltersForm.searchParamsPrev);
    renderActiveTagFacetsFromUrl();
    updateCounts();
    show_reset();

    FacetFiltersForm.isLoading = false;
    FacetFiltersForm.clearFacetCheckboxPending();
    FacetFiltersForm.setFacetControlsDisabled(false);
    FacetFiltersForm.toggleActiveFacets(false);

    document.body.dispatchEvent(new Event('contentUpdated'));
    if (typeof $ !== 'undefined') {
      $('body').trigger('filterUpdated');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const activeFilterIndex =
      FacetFiltersForm.pendingFacetContext?.filterIndex ||
      event?.target?.closest?.('.js-filter')?.dataset?.index;

    const matchesIndex = (element) =>
      activeFilterIndex ? element.dataset.index === activeFilterIndex : false;

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const index = element.dataset.index;
      if (!index) return;
      const target = document.querySelector(`.js-filter[data-index="${CSS.escape(index)}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && activeFilterIndex) {
      const targetFilter = document.querySelector(
        `.js-filter[data-index="${CSS.escape(activeFilterIndex)}"]`
      );
      if (targetFilter) FacetFiltersForm.renderCounts(countsToRender, targetFilter);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    const sourceActiveFacets = html.querySelector('#ProductGridContainer .active-facets');
    const targetActiveFacets = getActiveFacetsContainer();
    if (sourceActiveFacets && targetActiveFacets) {
      targetActiveFacets.innerHTML = sourceActiveFacets.innerHTML;
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      mobileForm.closest('menu-drawer')?.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid?.dataset?.id;
    if (!sectionId) return [];
    return [{ section: sectionId }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    const target = event.target;
    if (target.type === 'checkbox' || target.type === 'radio') {
      event.stopPropagation();
    } else {
      event.preventDefault();
    }

    if (FacetFiltersForm.isLoading) return;

    FacetFiltersForm.setCollectionProductLoading(true);
    FacetFiltersForm.setFacetControlsDisabled(true);
    FacetFiltersForm.setCountLoading(true);
    this.onSubmitForm(FacetFiltersForm.collectSearchParams(event), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('DOMContentLoaded', () => {
  syncTagFacetsFromUrl();
  renderActiveTagFacetsFromUrl();
  updateCounts();
  show_reset();
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
